<div #top class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div
                        [ngClass]="!isMobileXL() ? 'd-flex justify-content-between' : 'd-flex flex-column justify-content-center align-items-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>

                        <button mat-flat-button color="accent" (click)="regresarALaRutaAnterior()">
                            <mat-icon>arrow_left</mat-icon>
                            Volver al buscador</button>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div #pv class="container-custom-content animate__animated animate__fadeIn  buscador-pedidos">

    <mat-accordion multi>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Datos del pedido
                </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="pvForm">
                <div class="container-fluid mt-4">

                    <div class="row">

                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaCreacion}}</mat-label>

                                <input readonly [value]="pvForm.controls['fechaCreacion'].value | date:'dd/MM/yyyy'"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>


                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TipoOrden}}</mat-label>

                                <input readonly formControlName="tipoOrden" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOrdenSAP}}</mat-label>

                                <input readonly formControlName="nroOrdenSAP" type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroPedido}}</mat-label>

                                <input readonly formControlName="nroPedido" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-card class="mat-card-estado estadoPV_{{pvForm.get('idEstado').value}}">
                                <mat-card-content>{{pvForm.get('estado').value}}</mat-card-content>
                            </mat-card>
                        </div>
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>Fecha de Entrega</mat-label>
                                <input readonly matInput [matDatepicker]="picker" formControlName="fechaEntrega">
                                <mat-datepicker-toggle [disabled]="true" matSuffix
                                    [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <!-- <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TipoEntrega}}</mat-label>

                                <input readonly formControlName="tipoEntrega" type="text" matInput>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                        <mat-divider>
                        </mat-divider>
                    </div>


                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Division}}</mat-label>
                                <mat-select (selectionChange)='seleccionarDivision($event.value)'
                                    [compareWith]="compareDivisiones" formControlName="idDivision">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of divisiones" [value]="d.id">{{d.displayValue}}
                                    </mat-option>
                                </mat-select>

                                <mat-error
                                    *ngIf="(pvForm.get('idDivision').hasError('required')) && pvForm.get('idDivision').touched">
                                    {{Validaciones.IdDivision}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="divisionSeleccionada != null && (dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Division}}</mat-label>
                                <input readonly [value]="divisionSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div> -->

                    <div class="row">
                        <div *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Cliente}}</mat-label>
                                <input (change)="handleEmptyInputCliente($event)" matInput [matAutocomplete]="autoC"
                                    [formControl]="fcAutocompleteCliente" placeholder="Nro. cliente, nombre, etc...">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="Limpiar cliente seleccionado" (click)="limpiarCliente(true)">

                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoC="matAutocomplete"
                                    (optionSelected)='seleccionarCliente($event.option.value,null,null,null,null,null)'
                                    [displayWith]="getOptionTextCliente">
                                    <mat-option *ngIf="loadingFcAutocompleteCliente"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteCliente">
                                        <mat-option *ngFor="let cl of clientesEncontrados" [value]="cl">
                                            {{cl.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>

                        <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                            *ngIf="avisoCreditoVencido && pvForm.controls['idEstado'].value == 1 && alta">

                            <mat-card
                                class="mat-card-aviso-credito animate__animated animate__zoomIn animate__faster">
                                <H5>
                                    Aviso
                                </H5>

                                <mat-card-content>

                                    <p>{{Mensajes.CreditoVencido}}</p>

                                </mat-card-content>

                            </mat-card>
                        </div> -->


                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3"
                            *ngIf="this.mensajeCreditoExcedido && pvForm.controls['idEstado'].value == 1">

                            <mat-card [ngClass]="{
                                    'mat-card-aviso-credito': this.credito >= 0,
                                    'mat-card-aviso-credito-excedido': this.credito < 0
                                }" class="animate__animated animate__zoomIn animate__faster">


                                <mat-card-content>

                                    <p>{{this.mensajeCreditoExcedido}}</p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3"
                            *ngIf="this.mensajeDeudaVencida && pvForm.controls['idEstado'].value == 1">

                            <mat-card
                                class="mat-card-aviso-deuda-vencida animate__animated animate__zoomIn animate__faster">


                                <mat-card-content>

                                    <p>{{this.mensajeDeudaVencida}}</p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroCliente}}</mat-label>
                                <input readonly formControlName="nroCliente" type="text" matInput>
                                <mat-error
                                    *ngIf="(pvForm.get('nroCliente').hasError('required')) && pvForm.get('nroCliente').touched">
                                    {{Validaciones.Cliente}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NombreCliente}}</mat-label>
                                <input readonly formControlName="nombreCliente" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CuitCliente}}</mat-label>
                                <input readonly formControlName="cuit" type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <!-- <mat-form-field color="accent-darker" appearance="outline"
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta">
                                <mat-label>{{Etiquetas.IdGrupoCliente}}</mat-label>
                                <mat-select (selectionChange)='seleccionarGC($event.value)' [compareWith]="compareGC"
                                    formControlName="idGrupoCliente">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let gc of gcs" [value]="gc.id">{{gc.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(pvForm.get('idGrupoCliente').hasError('required')) && pvForm.get('idGrupoCliente').touched">
                                    {{Validaciones.IdGrupoCliente}}
                                </mat-error>
                            </mat-form-field> -->
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="gcSeleccionado != null && (dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.IdGrupoCliente}}</mat-label>
                                <input readonly [value]="gcSeleccionado.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>
                    </div>

                    <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                        <mat-divider>
                        </mat-divider>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                            <mat-form-field
                                *ngIf="!isInRole('VENDEDOR') && !dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.ZonaVendedor}}</mat-label>
                                <input (change)="handleEmptyInputVendedor($event)" matInput [matAutocomplete]="autoZV"
                                    [formControl]="fcAutocompleteZv" placeholder="Id, nombre, etc..">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="Limpiar vendedor seleccionado" (click)="limpiarVendedor(true)">

                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoZV="matAutocomplete"
                                    (optionSelected)='seleccionarZonaVendedor($event.option.value)'
                                    [displayWith]="getOptionTextZV">
                                    <mat-option *ngIf="loadingFcAutocompleteZV"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteZV">
                                        <mat-option *ngFor="let zv of zvsEncontradas" [value]="zv">
                                            {{zv.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div *ngIf="!isInRole('VENDEDOR')" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.ZonaVendedorSeleccionada}}</mat-label>
                                <input *ngIf="zvSeleccionada == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="zvSeleccionada != null" readonly [value]="zvSeleccionada.displayValue"
                                    type="text" matInput>
                                <mat-error
                                    *ngIf="(pvForm.get('idZonaVendedor').hasError('required')) && pvForm.get('idZonaVendedor').touched">
                                    {{Validaciones.ZonaVendedor}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div *ngIf="!isInRole('VENDEDOR')" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!isInRole('VENDEDOR') && !dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Region}}</mat-label>
                                <mat-select (selectionChange)='seleccionarRegion($event.value)'
                                    [compareWith]="compareRegiones" formControlName="idRegion">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let r of regiones" [value]="r.id">{{r.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(pvForm.get('idRegion').hasError('required')) && pvForm.get('idRegion').touched">
                                    {{Validaciones.IdRegion}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="regionSeleccionada != null && (isInRole('VENDEDOR') || dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Region}}</mat-label>
                                <input readonly [value]="regionSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <mat-form-field *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1"
                            color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.DireccionEntrega}}</mat-label>
                            <mat-select (selectionChange)='seleccionarDirEntrega($event.value)'
                                [compareWith]="compareDireccionEntrega" formControlName="nroClienteDireccionEntrega">
                                <mat-option [value]="">- Seleccione -</mat-option>
                                <mat-option *ngFor="let de of dirEntregas" [value]="de.nroCliente">{{de.displayValue}}
                                </mat-option>
                            </mat-select>

                            <mat-error
                                *ngIf="(pvForm.get('nroClienteDireccionEntrega').hasError('required')) && pvForm.get('nroClienteDireccionEntrega').touched">
                                {{Validaciones.DireccionEntrega}}
                            </mat-error>
                        </mat-form-field>

                    </div>
                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="dirEntregaSeleccionada != null">
                                <mat-label>{{Etiquetas.NroClienteDireccionEntrega}}</mat-label>

                                <input readonly [value]="dirEntregaSeleccionada.nroCliente" type="text" matInput>

                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="dirEntregaSeleccionada == null">
                                <mat-label>{{Etiquetas.NroClienteDireccionEntrega}}</mat-label>

                                <input readonly [value]="" type="text" matInput>

                            </mat-form-field>
                        </div>
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NombreClienteDireccionEntrega}}</mat-label>

                                <input readonly formControlName="nombreClienteDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CiudadDireccionEntrega}}</mat-label>

                                <input readonly formControlName="ciudadDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CalleNroDireccionEntrega}}</mat-label>

                                <input readonly formControlName="calleNroDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.CPDireccionEntrega}}</mat-label>

                            <input readonly formControlName="cpDireccionEntrega" type="text" matInput>
                        </mat-form-field>
                    </div> -->

                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CuentaDistribuidor}}</mat-label>
                                <mat-select [compareWith]="compareCuentasDistribuidores"
                                    formControlName="nroClienteDistribuidor"
                                    (selectionChange)='seleccionarCuentaDistribuidor($event.value,null)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of cuentasDistribuidores"
                                        [value]="d.nroClienteDistribuidor">{{d.nombre}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(pvForm.get('nroClienteDistribuidor').hasError('required')) && pvForm.get('nroClienteDistribuidor').touched">
                                    {{Validaciones.NroClienteDistribuidor}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="ctaDistrubuidorSeleccionada != null && (dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.CuentaDistribuidor}}</mat-label>
                                <input readonly [value]="ctaDistrubuidorSeleccionada.nombre" type="text" matInput>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Direccion}}</mat-label>
                                <mat-select [compareWith]="compareDirecciones" formControlName="idSucursal"
                                    (selectionChange)='seleccionarDireccion($event.value, null)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of direcciones" [value]="d.nroCliente">{{d.displayValue2}}
                                    </mat-option>
                                </mat-select>

                                <mat-error
                                    *ngIf="(pvForm.get('idSucursal').hasError('required')) && pvForm.get('idSucursal').touched">
                                    {{Validaciones.IdSucursal}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="direccionSeleccionada != null && (dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Direccion}}</mat-label>
                                <input readonly [value]="direccionSeleccionada.displayValue2" type="text" matInput>

                            </mat-form-field>
                        </div>
                    </div>
                    <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                        <mat-divider>
                        </mat-divider>
                    </div> -->


                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Comentario}}</mat-label>

                                <textarea #comentario matInput maxlength="1024" formControlName="comentario"
                                    type="text"></textarea>
                                <mat-hint align="start">Máximo: 1024
                                    caracteres</mat-hint>
                                <mat-hint align="end">{{comentario.value?.length
                                    || 0}} / 1024</mat-hint>

                            </mat-form-field>
                            <mat-form-field class="readonly-form-field"
                                *ngIf="dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Comentario}}</mat-label>

                                <textarea #comentario matInput readonly maxlength="1024" formControlName="comentario"
                                    type="text"></textarea>


                            </mat-form-field>
                        </div> -->
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field *ngIf="pvForm.controls['idEstado'].value == 1 && alta" color="accent-darker"
                                appearance="outline">
                                <mat-label>{{Etiquetas.Glosa}}</mat-label>

                                <input #glosa matInput maxlength="300" formControlName="glosa" type="text" matInput>

                                <mat-hint align="start">Máximo: 300
                                    caracteres</mat-hint>
                                <mat-hint align="end">{{glosa.value?.length || 0}} / 300</mat-hint>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" *ngIf="pvForm.controls['idEstado'].value != 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Glosa}}</mat-label>

                                <input #glosa matInput maxlength="300" readonly formControlName="glosa" type="text"
                                    matInput>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOC}}</mat-label>

                                <input matInput formControlName="nroOC" type="text">

                            </mat-form-field>
                            <mat-form-field class="readonly-form-field"
                                *ngIf="dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOC}}</mat-label>
                                <input readonly formControlName="nroOC" type="text" matInput>

                            </mat-form-field>

                        </div>
                    </div>
                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.MotivoRetencion}}</mat-label>

                            <input readonly formControlName="motivoRetencion" type="text" matInput>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.DescuentoDiscrecional}}</mat-label>

                            <input appTwoDigitDecimaNumber readonly
                                [value]="pvForm.controls['descuentoDiscrecional'].value | number : '1.2-2'" type="text"
                                matInput>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field
                            *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                            color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.IdMoneda}}</mat-label>
                            <mat-select [hidden]="dataSourceItems.data.length"
                                (selectionChange)='seleccionarMoneda($event.value)' [compareWith]="compareMonedas"
                                formControlName="idMoneda">
                                <mat-option [value]="">- Seleccione -</mat-option>
                                <mat-option *ngFor="let m of monedas" [value]="m.id">{{m.id}}
                                </mat-option>
                            </mat-select>
                            <input *ngIf="monedaSeleccionada != null && dataSourceItems.data.length" readonly
                                [value]="monedaSeleccionada.id" type="text" matInput>
                            <mat-error
                                *ngIf="(pvForm.get('idMoneda').hasError('required')) && pvForm.get('idMoneda').touched">
                                {{Validaciones.IdMoneda}}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                            *ngIf="monedaSeleccionada != null && (dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1)">
                            <mat-label>{{Etiquetas.IdMoneda}}</mat-label>
                            <input readonly [value]="monedaSeleccionada.id" type="text" matInput>

                        </mat-form-field>
                    </div> -->





                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                        <mat-divider>
                        </mat-divider>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TipoListaPrecios}}</mat-label>
                                <mat-select [compareWith]="compareLPs" formControlName="idTipoListaPrecios"
                                    (selectionChange)='seleccionarLP($event.value, null)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let lp of lps" [value]="lp.id">
                                        {{lp.displayValue}}
                                    </mat-option>
                                </mat-select>

                                <mat-error
                                    *ngIf="(pvForm.get('idTipoListaPrecios').hasError('required')) && pvForm.get('idTipoListaPrecios').touched">
                                    {{Validaciones.ListaPrecios}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="lpSeleccionada != null && (dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.TipoListaPrecios}}</mat-label>
                                <input readonly [value]="lpSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>

                        <!--   <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TipoListaPrecios}}</mat-label>
                                <input (change)="handleEmptyInputLP($event)" matInput [matAutocomplete]="autoLP"
                                    [formControl]="fcAutocompleteLP" placeholder="Id, descripción, etc..">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="Limpiar lista precios seleccionada" (click)="limpiarLP(true)">
                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoLP="matAutocomplete"
                                    (optionSelected)='seleccionarLP($event.option.value,null)'
                                    [displayWith]="getOptionTextLP">
                                    <mat-option *ngIf="loadingFcAutocompleteDirEntrega"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteLP">
                                        <mat-option *ngFor="let lp of lpsEncontradas" [value]="lp">
                                            {{lp.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.TipoListaPrecios}}</mat-label>

                            <input readonly formControlName="idTipoListaPrecios" type="text" matInput>
                            <mat-error
                                *ngIf="(pvForm.get('idTipoListaPrecios').hasError('required')) && pvForm.get('idTipoListaPrecios').touched">
                                {{Validaciones.ListaPrecios}}
                            </mat-error>

                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.TipoListaPrecios}}</mat-label>

                            <input readonly formControlName="tipoListaPrecios" type="text" matInput>

                        </mat-form-field>
                    </div> -->

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="pvForm.controls['idEstado'].value == 1 && alta && !dataSourceItems.data.length"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TerminoPago}}</mat-label>
                                <mat-select [compareWith]="compareTerminosPago" formControlName="idTerminoPago"
                                    (selectionChange)='seleccionarTP($event.value)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let t of terminosPago" [value]="t.id">{{t.descripcion}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(pvForm.get('idTerminoPago').hasError('required')) && pvForm.get('idTerminoPago').touched">
                                    {{Validaciones.IdTerminoPago}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="tpSeleccionado != null && (dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.TerminoPago}}</mat-label>
                                <input readonly [value]=" tpSeleccionado.descripcion" type="text" matInput>

                            </mat-form-field>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && pvForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaPrecio}}</mat-label>
                                <input readonly matInput [matDatepicker]="picker" formControlName="fechaPrecio"
                                    [min]="minDate">

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker formControlName="fechaPrecio" #picker></mat-datepicker>

                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="dataSourceItems.data.length || pvForm.controls['idEstado'].value != 1">
                                <mat-label>{{Etiquetas.FechaPrecio}}</mat-label>

                                <input readonly [value]="pvForm.controls['fechaPrecio'].value | date:'dd/MM/yyyy'"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>

                </div>
            </form>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Ítems del pedido
                </mat-panel-title>


            </mat-expansion-panel-header>
            <form [formGroup]="pvItemForm">
                <div class="container-fluid mt-4">

                    <div class="row align-items-center" *ngIf="pvForm.controls['idEstado'].value == 1 && alta">

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Item}}</mat-label>
                                <input (change)="handleEmptyInputItem($event)" matInput [matAutocomplete]="autoItem"
                                    [formControl]="fcAutocompleteItem" placeholder="Código, descripción, etc..">
                                <button type="button" matSuffix mat-icon-button (click)="limpiarItem(true)"
                                    matTooltip="Limpiar ítem seleccionado">
                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoItem="matAutocomplete"
                                    (optionSelected)='seleccionarItem($event.option.value)'
                                    [displayWith]="getOptionTextItem">
                                    <mat-option *ngIf="loadingFcAutocompleteItem"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteItem">
                                        <mat-option *ngFor="let i of itemsEncontrados" [value]="i">
                                            {{i.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CantidadDisponible}}</mat-label>
                                <input readonly [value]=" cantidadDisponible.value | number:'':'es-AR'" type="text"
                                    matInput>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Cantidad}}</mat-label>
                                <input appThreeDigitDecimaNumber formControlName="cantidad" matInput type="text">
                                <mat-error
                                    *ngIf="!pvItemForm.controls['cantidad'].valid && pvItemForm.get('cantidad').touched">
                                    {{Validaciones.Cantidad}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3" *ngIf="avisoUnidadesPallet">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeUnidadesPallet}} </p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                        <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.PrecioUnitarioLista}}</mat-label>
                                <input *ngIf="itemSeleccionado == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="itemSeleccionado != null" readonly
                                    [value]="itemSeleccionado.tasa | number : '1.2-2'" type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                                <input *ngIf="itemSeleccionado == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="itemSeleccionado != null" readonly [value]="itemSeleccionado.idProducto"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Producto}}</mat-label>
                                <input *ngIf="itemSeleccionado == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="itemSeleccionado != null" readonly [value]="itemSeleccionado.producto"
                                    type="text" matInput>
                            </mat-form-field>
                        </div> -->

                        <div class="mat-toolbar-custom">
                            <mat-toolbar>
                                <mat-toolbar-row>

                                    <button mat-flat-button color="accent" (click)="nuevoItem()">
                                        <mat-icon>add</mat-icon>
                                        Nuevo ítem / Cargar ítem</button>

                                </mat-toolbar-row>

                            </mat-toolbar>

                        </div>



                    </div>
                    <div class="row align-items-center">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3 mt-3"
                            *ngIf="descuentosDiscrecionalesNegativos">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">
                                <H5>
                                    Aviso
                                </H5>

                                <mat-card-content>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                            {{Mensajes.DescuentosNegativos}}
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                            <ul *ngIf="itemsConDescuentoDiscrecionalNegativo.length">
                                                <li *ngFor="let item of itemsConDescuentoDiscrecionalNegativo">
                                                    {{ item.idProducto }} - {{ item.producto }}
                                                    ({{item.descuentoDiscrecional | number : '1.2-2'}} %)
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </mat-card-content>

                            </mat-card>
                        </div>

                    </div>
                    <div class="mat-table-pedidos">
                        <table [hidden]="codigoEdit == 0" mat-table matTableResponsive [dataSource]="dataSourceItems"
                            matSort #matSortItems="matSort" matSortActive="nroLinea" matSortDirection="asc">

                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Acciones}} </th>
                                <td mat-cell *matCellDef="let pvi">
                                    <div>

                                        <button *ngIf="pvForm.controls['idEstado'].value == 1 && alta"
                                            matTooltip="{{Tooltips.Editar}}" (click)="dialogItem(pvi)" mat-icon-button
                                            color="primary-darker">
                                            <mat-icon color="accent-darker">edit</mat-icon>
                                        </button>

                                        <button *ngIf="pvForm.controls['idEstado'].value == 1 && alta"
                                            (click)="eliminarItem(pvi)" matTooltip="{{Tooltips.Eliminar}}"
                                            mat-icon-button color="primary-darker">
                                            <mat-icon color="accent-darker">delete</mat-icon>
                                        </button>

                                    </div>

                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="nroLinea">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.NroLinea}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.nroLinea}} </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>
                            <ng-container matColumnDef="idProducto">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.IdProducto}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.idProducto}} </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="producto">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.Producto}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.producto}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="cantidad">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.Cantidad}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.cantidad | number}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>


                            <ng-container matColumnDef="precioUnitarioLista">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.PrecioUnitarioLista}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.precioUnitarioLista | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="totalDescuento">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <!-- {{Etiquetas.TotalDescuento}} -->
                                    - Descuento
                                </th>
                                <td mat-footer-cell *matFooterCellDef> </td>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.totalDescuento | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <!-- <ng-container matColumnDef="idMoneda">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.IdMoneda}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.idMoneda}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container> -->


                            <!-- <ng-container matColumnDef="precioUnitarioFinal">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.PrecioUnitarioFinal}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.precioUnitarioFinal | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container> -->

                            <ng-container matColumnDef="recargo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <!-- {{Etiquetas.Recargo}} -->
                                    + Interés
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.recargo | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="totalPrecioKGL">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <!-- {{Etiquetas.TotalPrecioKGL}} -->
                                    = Precio Final U.
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.totalPrecioKGL | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> Total </td>
                            </ng-container>

                            <ng-container matColumnDef="total">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.Total}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.total | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> {{totalItems | number : '1.2-2'}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsItems"></tr>
                            <tr mat-row *matRowDef="let pvi; columns: displayedColumnsItems;">
                            </tr>
                            <tr mat-footer-row *matFooterRowDef="displayedColumnsItems"></tr>
                            <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                <td class="mat-cell" [attr.colspan]="displayedColumnsItems.length">
                                    {{Etiquetas.SinRegistros}}
                                </td>
                            </tr>
                        </table>

                        <mat-paginator #matPaginatorItems="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                            showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </div>
            </form>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="dataSourceItems.data.length" [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Ítems descuento
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="container-fluid mt-4">


                <div class="mat-table-pedidos">
                    <table [hidden]="codigoEdit == 0" mat-table matTableResponsive
                        [dataSource]="dataSourceItemsDescuentos" matSort #matSortItemsDescuentos="matSort"
                        matSortActive="nroLinea" matSortDirection="asc">


                        <ng-container matColumnDef="nroLinea">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.NroLinea}}
                            </th>
                            <td mat-cell *matCellDef="let desc">
                                {{desc.nroLinea}} </td>
                        </ng-container>
                        <ng-container matColumnDef="idProducto">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.IdProducto}}
                            </th>
                            <td mat-cell *matCellDef="let desc">
                                {{desc.idProducto}} </td>
                        </ng-container>

                        <ng-container matColumnDef="producto">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Producto}}
                            </th>
                            <td mat-cell *matCellDef="let desc">
                                {{desc.producto}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="idTipoCondicion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.IdTipoCondicion}}
                            </th>
                            <td mat-cell *matCellDef="let desc">
                                {{desc.idTipoCondicion}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="tipoCondicion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.DescripcionItemDescuento}}
                            </th>
                            <td mat-cell *matCellDef="let desc">
                                {{desc.tipoCondicion}}
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="importe">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Importe}}
                            </th>
                            <td mat-cell *matCellDef="let desc">
                                <div [hidden]="!desc.totalTr">

                                </div>
                                <div [hidden]="desc.totalTr">
                                    {{desc.importe | number : '1.2-2'}}

                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="porcentaje">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Porcentaje}}
                            </th>
                            <td mat-cell *matCellDef="let desc">
                                <div style="font-weight: bold;" [hidden]="!desc.totalTr">
                                    Total
                                </div>
                                <div [hidden]="desc.totalTr">
                                    {{desc.porcentaje | number : '1.2-2'}}

                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="descuento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Descuento}}
                            </th>
                            <td mat-cell *matCellDef="let desc">
                                <div style="font-weight: bold;" [hidden]="!desc.totalTr">
                                    {{desc.descuento | number : '1.2-2'}}
                                </div>
                                <div [hidden]="desc.totalTr">
                                    {{desc.descuento | number : '1.2-2'}}
                                </div>
                            </td>
                        </ng-container>



                        <tr mat-header-row *matHeaderRowDef="displayedColumnsItemsDescuentos"></tr>
                        <tr mat-row *matRowDef="let desc; columns: displayedColumnsItemsDescuentos;"
                            [ngStyle]="{'background': desc.totalTr ? '#d5ffd5' : '' }">s

                        </tr>


                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumnsItemsDescuentos.length">
                                {{Etiquetas.SinRegistros}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator #matPaginatorItemsDescuentos="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>

        </mat-expansion-panel>

        <mat-expansion-panel
            *ngIf="dataSourceItems.data.length && (dataSourceFacturas.data.length || dataSourceRemitos.data.length) "
            [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Facturas / Guías de Despacho
                </mat-panel-title>


            </mat-expansion-panel-header>

            <mat-tab-group>
                <mat-tab label="Facturas">
                    <div class="container-fluid">
                        <div class="row align-items-center justify-content-evenly">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                                <mat-form-field color="accent-darker" appearance="standard">
                                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                                    <input matInput (keyup)="applyFilterFactura($event)" #input>
                                </mat-form-field>

                                <div class="mat-table-pedidos">
                                    <table mat-table matTableResponsive [dataSource]="dataSourceFacturas" matSort
                                        #matSortFacturas="matSort" matSortActive="nroLinea" matSortDirection="asc">


                                        <ng-container matColumnDef="acciones">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{Etiquetas.Acciones}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">

                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="nroLinea">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.NroLinea}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                {{f.nroLinea}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="nroFactura">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.NroFactura}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                {{f.nroFactura}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="nroRemito">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.NroRemito}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                {{f.nroRemito}}
                                            </td>
                                        </ng-container>


                                        <ng-container matColumnDef="fechaVencimiento">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.FechaVencimiento}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                {{f.fechaVencimiento}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="idProducto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.IdProducto}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                {{f.idProducto}}
                                            </td>
                                        </ng-container>


                                        <ng-container matColumnDef="idLote">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.IdLote}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                {{f.idLote}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="cantidad">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.Cantidad}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                {{f.cantidad | number}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="totalFactura">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.TotalFactura}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                {{f.totalFactura}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="nombrePDF">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.NombrePDF}}
                                            </th>
                                            <td mat-cell *matCellDef="let f">
                                                <a class="linkPDFs" (click)="download(f.nombrePDF)">
                                                    {{f.nombrePDF}}
                                                </a>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumnsFacturas"></tr>
                                        <tr mat-row *matRowDef="let f; columns: displayedColumnsFacturas;">
                                        </tr>


                                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                            <td class="mat-cell" [attr.colspan]="displayedColumnsFacturas.length">
                                                {{Etiquetas.SinRegistros}}
                                            </td>
                                        </tr>
                                    </table>

                                    <mat-paginator #matPaginatorFacturas="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                                        showFirstLastButtons>
                                    </mat-paginator>
                                </div>


                            </div>

                        </div>

                    </div>
                </mat-tab>

                <mat-tab label="Guías de Despacho">
                    <div class="container-fluid">
                        <div class="row align-items-center justify-content-evenly">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                                <mat-form-field color="accent-darker" appearance="standard">
                                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                                    <input matInput (keyup)="applyFilterRemitos($event)" #input>
                                </mat-form-field>

                                <div class="mat-table-pedidos">
                                    <table mat-table matTableResponsive [dataSource]="dataSourceRemitos" matSort
                                        #matSortRemitos="matSort" matSortActive="nroRemito" matSortDirection="asc">


                                        <ng-container matColumnDef="acciones">
                                            <th mat-header-cell *matHeaderCellDef>
                                                {{Etiquetas.Acciones}}
                                            </th>
                                            <td mat-cell *matCellDef="let r">

                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="nroRemito">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.NroRemito}}
                                            </th>
                                            <td mat-cell *matCellDef="let r">
                                                {{r.nroRemito}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="idProducto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.IdProducto}}
                                            </th>
                                            <td mat-cell *matCellDef="let r">
                                                {{r.idProducto}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="idLote">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.IdLote}}
                                            </th>
                                            <td mat-cell *matCellDef="let r">
                                                {{r.idLote}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="cantidad">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.Cantidad}}
                                            </th>
                                            <td mat-cell *matCellDef="let r">
                                                {{r.cantidad | number}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="fecha">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.Fecha}}
                                            </th>
                                            <td mat-cell *matCellDef="let r">
                                                {{r.fecha}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="nombrePDF">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{Etiquetas.NombrePDF}}
                                            </th>
                                            <td mat-cell *matCellDef="let r">
                                                <a class="linkPDFs" (click)="download(r.nombrePDF)">
                                                    {{r.nombrePDF}}
                                                </a>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumnsRemitos">
                                        </tr>
                                        <tr mat-row *matRowDef="let r; columns: displayedColumnsRemitos;">
                                        </tr>


                                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                            <td class="mat-cell" [attr.colspan]="displayedColumnsRemitos.length">
                                                {{Etiquetas.SinRegistros}}
                                            </td>
                                        </tr>
                                    </table>

                                    <mat-paginator #matPaginatorRemitos="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                                        showFirstLastButtons>
                                    </mat-paginator>
                                </div>


                            </div>

                        </div>

                    </div>
                </mat-tab>

            </mat-tab-group>

        </mat-expansion-panel>
    </mat-accordion>
    <div class="mat-toolbar-custom">
        <mat-toolbar>
            <mat-toolbar-row>

                <button mat-flat-button color="accent" (click)="guardar()"
                    *ngIf="pvForm.controls['idEstado'].value == 1 && alta">
                    <mat-icon>add</mat-icon>
                    Guardar</button>



                <button *ngIf="codigoEdit != 0" mat-flat-button color="accent" (click)="dialogLogAutorizaciones()">
                    <mat-icon>search</mat-icon>
                    Workflow</button>

                <button
                    *ngIf="isInRole('VENDEDOR') && (pvForm.controls['idEstado'].value == 2 || pvForm.controls['idEstado'].value == 3 )"
                    mat-flat-button color="accent" (click)="dialogNroOC()">
                    <mat-icon>edit</mat-icon>
                    Ingresar Nro. OC </button>

                <button
                    *ngIf="retenciones?.length > 0 && ((codigoEdit != 0 && pvForm.controls['idEstado'].value != 1) || pvForm.controls['idEstado'].value != 1)"
                    mat-flat-button color="warn" (click)="dialogRetenciones()">
                    <mat-icon>search</mat-icon>
                    Motivos Retención</button>




                <!-- <button *ngIf="pvForm.controls['rechazar'].value == true && pvForm.controls['idEstado'].value == 1"
                    mat-flat-button color="warn" (click)="dialogComentario(3,true)">
                    <mat-icon>front_hand</mat-icon>
                    Rechazar cotización</button>
                    -->
                <button
                    *ngIf="pvForm.valid && dataSourceItems.data.length && pvForm.controls['aprobar'].value == true && pvForm.controls['idEstado'].value != 3"
                    mat-flat-button color="primary" (click)="dialogComentario(1,false)">
                    <mat-icon>thumb_up</mat-icon>
                    Aprobar</button>

                <button
                    *ngIf="pvForm.valid && dataSourceItems.data.length && pvForm.controls['idEstado'].value == 7 && pvForm.controls['enviadoDistribuidor'].value == false && (isInRole('ADM') ||isInRole('CONTING LOGISTICA') || isInRole('LOGISTICA'))"
                    mat-flat-button color="primary" (click)="envioMailDistribuidor()">
                    <mat-icon>mail</mat-icon>Enviar a Distribuidor
                </button>
                <button
                    *ngIf="pvForm.valid && dataSourceItems.data.length && pvForm.controls['idEstado'].value == 3 && (isInRole('COBRANZAS/CTAS.CTES') || isInRole('CREDITOS') )"
                    mat-flat-button color="primary" (click)="dialogAprobacionRetenido()">
                    <mat-icon>thumb_up</mat-icon>
                    Aprobar</button>
                <!-- puede rechazar los adm y tambien los que esten habilitados a aprobar -->
                <button
                    *ngIf="(pvForm.controls['rechazar'].value == true && pvForm.controls['idEstado'].value != 1) || (pvForm.controls['aprobar'].value == true && (pvForm.controls['idEstado'].value == 2 || pvForm.controls['idEstado'].value == 3))"
                    mat-flat-button color="warn" (click)="dialogComentario(2,true)">
                    <mat-icon>thumb_down</mat-icon>
                    Rechazar</button>
                <span class="mat-toolbar-row-separador"></span>
                <button mat-flat-button color="accent" (click)="regresarALaRutaAnterior()">
                    <mat-icon>arrow_left</mat-icon>
                    Volver al buscador</button>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
</div>